import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { C } from '../../constants/design-tokens';

export type ToolBtnVariant = 'default' | 'danger';

type ToolBtnProps = {
  onClick: () => void;
  children: React.ReactNode;
  title?: string;
  active?: boolean;
  variant?: ToolBtnVariant;
  size?: number;
  flex?: boolean;
  disabled?: boolean;
};

const getStyles = (isDanger: boolean, active: boolean, isHovered: boolean, disabled: boolean): React.CSSProperties => {
  if (isDanger) {
    return {
      background: isHovered && !disabled ? C.dangerSurface : 'transparent',
      color: isHovered && !disabled ? C.danger : C.textMuted,
      border: 'none'
    };
  }

  const showAccent = (active || isHovered) && !disabled;
  return {
    background: showAccent ? C.accentSurface : 'transparent',
    color: showAccent ? C.accent : C.textSecondary,
    border: 'none'
  };
};

export const ToolBtn: React.FC<ToolBtnProps> = ({
  onClick,
  children,
  title,
  active = false,
  variant = 'default',
  size = 32,
  flex = false,
  disabled = false
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const isDanger = variant === 'danger';
  const variantStyles = getStyles(isDanger, active, isHovered, disabled);

  const btn = (
    <button
      disabled={disabled}
      onClick={onClick}
      title={title}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: flex ? '100%' : `${size}px`,
        height: `${size}px`,
        flex: flex ? 1 : undefined,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '6px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        flexShrink: 0,
        transition: 'background 0.15s, color 0.15s',
        opacity: disabled ? 0.5 : 1,
        ...variantStyles
      }}
    >
      {children}
    </button>
  );

  if (title) {
    return (
      <Tooltip title={title} placement='topLeft'>
        {btn}
      </Tooltip>
    );
  }

  return btn;
};
